import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=5fc299c6"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports